$wj([17],{

/***/ 1914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MessageAdReadingPane_1 = __webpack_require__(5555);
exports.MessageAdReadingPane = MessageAdReadingPane_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InfoBarMessageSource;
(function (InfoBarMessageSource) {
    InfoBarMessageSource[InfoBarMessageSource["Compose"] = 0] = "Compose";
    InfoBarMessageSource[InfoBarMessageSource["Extensibility"] = 1] = "Extensibility";
    InfoBarMessageSource[InfoBarMessageSource["ReadingPane"] = 2] = "ReadingPane";
})(InfoBarMessageSource = exports.InfoBarMessageSource || (exports.InfoBarMessageSource = {}));
var InfoBarMessageRank;
(function (InfoBarMessageRank) {
    InfoBarMessageRank[InfoBarMessageRank["Safety"] = 0] = "Safety";
    InfoBarMessageRank[InfoBarMessageRank["Error"] = 1] = "Error";
    InfoBarMessageRank[InfoBarMessageRank["Info"] = 2] = "Info";
})(InfoBarMessageRank = exports.InfoBarMessageRank || (exports.InfoBarMessageRank = {}));
var InfoBarMessageColor;
(function (InfoBarMessageColor) {
    InfoBarMessageColor[InfoBarMessageColor["Grey"] = 0] = "Grey";
    InfoBarMessageColor[InfoBarMessageColor["Red"] = 1] = "Red";
    InfoBarMessageColor[InfoBarMessageColor["Green"] = 2] = "Green";
    InfoBarMessageColor[InfoBarMessageColor["Yellow"] = 3] = "Yellow";
})(InfoBarMessageColor = exports.InfoBarMessageColor || (exports.InfoBarMessageColor = {}));
//# sourceMappingURL=InfoBarMessageViewState.js.map

/***/ }),

/***/ 2802:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(15);
__webpack_require__(3460);
exports.getStore = satcheljs_1.createStore('messageAdStore', {
    adIds: [],
    messageAdRowStore: mobx_1.map({}),
});
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2908:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['outlookAdSenderText', 'outlookAdSubject', 'outlookAdPreview', 'generalCallToAction', 'adMessageInfobarDisclamer', 'aboutOurAdsContextMenu', 'removeAdContextMenu', 'removeAdButtonText', 'adTextSubjectLabel'];
var stringModule = index_1.registerStringPackage('owa-messagead-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 2948:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MessageAdType_1 = __webpack_require__(3458);
exports.MessageAdType = MessageAdType_1.default;
var populateAds_1 = __webpack_require__(3459);
exports.populateAds = populateAds_1.default;
var removeMessageAd_1 = __webpack_require__(3113);
exports.removeMessageAd = removeMessageAd_1.default;
var removeMessageAdClearList_1 = __webpack_require__(3461);
exports.removeMessageAdClearList = removeMessageAdClearList_1.default;
// Store
var store_1 = __webpack_require__(2802);
exports.getStore = store_1.getStore;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var InfoBarMessage_1 = __webpack_require__(3107);
var InfoBar = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBar, _super);
    function InfoBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoBar.prototype.render = function () {
        // VSO 1777: add collapse/expand behavior to info bar
        // VSO 1778: sort info messages in info bar based on ranks
        return this.props.messages.length > 0 ? (React.createElement("div", { className: this.props.className }, this.props.messages.map(function (message) { return (React.createElement(InfoBarMessage_1.default, tslib_1.__assign({ key: message.key }, message))); }))) : null;
    };
    InfoBar = tslib_1.__decorate([
        mobx_react_1.observer
    ], InfoBar);
    return InfoBar;
}(React.Component));
exports.default = InfoBar;
//# sourceMappingURL=InfoBar.js.map

/***/ }),

/***/ 3107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var InfoBarMessageWithCustomAction_1 = __webpack_require__(3108);
var InfoBarMessageWithShowDetailsAction_1 = __webpack_require__(3109);
var mobx_react_1 = __webpack_require__(11);
var Icon_1 = __webpack_require__(43);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var React = __webpack_require__(3);
var InfoBarMessageViewState_1 = __webpack_require__(2643);
var styles = __webpack_require__(3110);
var classNames = __webpack_require__(30).bind(styles);
var InfoBarMessage = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBarMessage, _super);
    function InfoBarMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textContainerRefGetter = function () {
            return _this.textContainerRef;
        };
        return _this;
    }
    InfoBarMessage.prototype.renderPart = function (part) {
        if (typeof part === 'string') {
            return part;
        }
        else if (part.text) {
            var customAction = part;
            return (React.createElement(InfoBarMessageWithCustomAction_1.default, { customAction: customAction, className: styles.link }));
        }
        else {
            var showDetailsAction = part;
            return (React.createElement(InfoBarMessageWithShowDetailsAction_1.default, tslib_1.__assign({}, showDetailsAction, { className: styles.link, detailContainerGetter: this.textContainerRefGetter })));
        }
    };
    InfoBarMessage.prototype.render = function () {
        var _this = this;
        // Set safety color binding to null if it's not a safety bar message.
        var safetyColorBinding = this.props.rank == InfoBarMessageViewState_1.InfoBarMessageRank.Safety
            ? {
                red: this.props.color == InfoBarMessageViewState_1.InfoBarMessageColor.Red,
                green: this.props.color == InfoBarMessageViewState_1.InfoBarMessageColor.Green,
                yellow: this.props.color == InfoBarMessageViewState_1.InfoBarMessageColor.Yellow,
            }
            : null;
        return (React.createElement("div", { className: classNames(styles.container, owa_controls_feature_flags_1.isControlFeatureEnabled('rp-newInfoBarUI')
                ? styles.newInfoBarUI
                : safetyColorBinding) },
            owa_controls_feature_flags_1.isControlFeatureEnabled('rp-newInfoBarUI') ? (React.createElement(Icon_1.Icon, { iconName: "Info" /* Info */, className: classNames(styles.icon, safetyColorBinding) })) : (React.createElement("div", { className: classNames(styles.bar, safetyColorBinding) })),
            React.createElement("div", { ref: function (ref) { return (_this.textContainerRef = ref); }, className: styles.textContainer }, this.props.messageParts.map(function (part, index) { return (React.createElement("span", { key: index },
                _this.renderPart(part),
                " ")); }))));
    };
    InfoBarMessage = tslib_1.__decorate([
        mobx_react_1.observer
    ], InfoBarMessage);
    return InfoBarMessage;
}(React.Component));
exports.default = InfoBarMessage;
//# sourceMappingURL=InfoBarMessage.js.map

/***/ }),

/***/ 3108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var InfoBarMessageWithCustomAction = function (props) {
    var customActionClickHandler = function (action) {
        return function (evt) {
            evt.stopPropagation();
            action();
        };
    };
    return (React.createElement("a", { className: props.className, onClick: customActionClickHandler(props.customAction.action) }, props.customAction.text));
};
exports.default = InfoBarMessageWithCustomAction;
//# sourceMappingURL=InfoBarMessageWithCustomAction.js.map

/***/ }),

/***/ 3109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var InfoBarMessageWithShowDetailsAction = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBarMessageWithShowDetailsAction, _super);
    function InfoBarMessageWithShowDetailsAction(props) {
        var _this = _super.call(this, props) || this;
        _this.showDetails = function (evt) {
            evt.stopPropagation();
            _this.props.detailContainerGetter().appendChild(_this.props.detailsDom);
            _this.setState({ isShowingDetails: true });
        };
        _this.hideDetails = function (evt) {
            evt.stopPropagation();
            _this.props.detailContainerGetter().removeChild(_this.props.detailsDom);
            _this.setState({ isShowingDetails: false });
        };
        _this.state = { isShowingDetails: false };
        return _this;
    }
    InfoBarMessageWithShowDetailsAction.prototype.render = function () {
        var clickHandler = this.state.isShowingDetails ? this.hideDetails : this.showDetails;
        return (React.createElement("a", { className: this.props.className, onClick: clickHandler }, this.state.isShowingDetails
            ? this.props.hideDetailsText
            : this.props.showDetailsText));
    };
    InfoBarMessageWithShowDetailsAction = tslib_1.__decorate([
        mobx_react_1.observer
    ], InfoBarMessageWithShowDetailsAction);
    return InfoBarMessageWithShowDetailsAction;
}(React.Component));
exports.default = InfoBarMessageWithShowDetailsAction;
//# sourceMappingURL=InfoBarMessageWithShowDetailsAction.js.map

/***/ }),

/***/ 3110:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3111);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3111:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._29SnJllCVbi8e40GWbvbmE{min-height:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}html[dir] ._29SnJllCVbi8e40GWbvbmE{margin:10px 0;background:#f4f4f4}html[dir] ._29SnJllCVbi8e40GWbvbmE._2OKW0Tp0uQe21WQEvRxDXT{background:#fde7e9}html[dir] ._29SnJllCVbi8e40GWbvbmE._25PlWhOttGVYj_Nh9N8OrI{background:#f1f9f2}html[dir] ._29SnJllCVbi8e40GWbvbmE._2IJS7onxizlED3tpu7Qndm{background:#fdfae7}._9kSF2asGyM-7Kd7whZob9{-webkit-box-flex:0;-ms-flex:0 0 5px;flex:0 0 5px}html[dir] ._9kSF2asGyM-7Kd7whZob9{background:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir] ._9kSF2asGyM-7Kd7whZob9._2OKW0Tp0uQe21WQEvRxDXT{background:#a80000}html[dir] ._9kSF2asGyM-7Kd7whZob9._25PlWhOttGVYj_Nh9N8OrI{background:#56a659}html[dir] ._9kSF2asGyM-7Kd7whZob9._2IJS7onxizlED3tpu7Qndm{background:#fcd146}._31FfEO1yVzudX1ujMm27Uh{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;color:#212121;font-size:12px;font-weight:400}html[dir=ltr] ._31FfEO1yVzudX1ujMm27Uh{margin:7px 7px 7px 15px}html[dir=rtl] ._31FfEO1yVzudX1ujMm27Uh{margin:7px 15px 7px 7px}._1EhXq2QY4sISmd8L_Ce6LF{color:\"[theme:themeDark, default:#0D62AA]\";cursor:pointer}._1nrypaR4W1ERb_I8gvotmj._29SnJllCVbi8e40GWbvbmE{-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:10px}html[dir] ._1nrypaR4W1ERb_I8gvotmj._29SnJllCVbi8e40GWbvbmE{background:\"[theme:richUserContentBackground, default:#FFFFFF]\";margin:0;padding-bottom:12px}html[dir] ._1nrypaR4W1ERb_I8gvotmj ._31FfEO1yVzudX1ujMm27Uh{margin:0}html[dir=ltr] ._1nrypaR4W1ERb_I8gvotmj ._31FfEO1yVzudX1ujMm27Uh{margin-left:27px}html[dir=rtl] ._1nrypaR4W1ERb_I8gvotmj ._31FfEO1yVzudX1ujMm27Uh{margin-right:27px}._1nrypaR4W1ERb_I8gvotmj ._3z2xLmEuBBC2uEKtKJQaeu{font-size:13px;color:\"[theme:neutralTertiary, default:#a6a6a6]\"}._1nrypaR4W1ERb_I8gvotmj ._3z2xLmEuBBC2uEKtKJQaeu._2OKW0Tp0uQe21WQEvRxDXT{color:#a80000}._1nrypaR4W1ERb_I8gvotmj ._3z2xLmEuBBC2uEKtKJQaeu._25PlWhOttGVYj_Nh9N8OrI{color:#56a659}._1nrypaR4W1ERb_I8gvotmj ._3z2xLmEuBBC2uEKtKJQaeu._2IJS7onxizlED3tpu7Qndm{color:#fcd146}", ""]);

// exports
exports.locals = {
	"container": "_29SnJllCVbi8e40GWbvbmE",
	"red": "_2OKW0Tp0uQe21WQEvRxDXT",
	"green": "_25PlWhOttGVYj_Nh9N8OrI",
	"yellow": "_2IJS7onxizlED3tpu7Qndm",
	"bar": "_9kSF2asGyM-7Kd7whZob9",
	"textContainer": "_31FfEO1yVzudX1ujMm27Uh",
	"link": "_1EhXq2QY4sISmd8L_Ce6LF",
	"newInfoBarUI": "_1nrypaR4W1ERb_I8gvotmj",
	"icon": "_3z2xLmEuBBC2uEKtKJQaeu"
};

/***/ }),

/***/ 3112:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5559);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.action('REMOVE_MESSAGEAD', function (removeAdId) {
    return {
        removeAdId: removeAdId,
    };
});
//# sourceMappingURL=removeMessageAd.js.map

/***/ }),

/***/ 3458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Enum for the message Adtype
 */
var MessageAdType;
(function (MessageAdType) {
    MessageAdType["OutlookUpSell"] = "OutlookUpSell";
    MessageAdType["BingOneClick"] = "BingOneClick";
    MessageAdType["BingOneClickOIO"] = "BingOneClickOIO";
    MessageAdType["BingTwoClick"] = "BingTwoClick";
    MessageAdType["AppNexusOneClick"] = "AppNexusOneClick";
    MessageAdType["AppNexusOneClickOIO"] = "AppNexusOneClickOIO";
    MessageAdType["AppNexusTwoClick"] = "AppNexusTwoClick";
    MessageAdType["TaboolaOneClick"] = "TaboolaOneClick";
    MessageAdType["TaboolaOneClickOIO"] = "TaboolaOneClickOIO";
    MessageAdType["TaboolaTwoClick"] = "TaboolaTwoClick";
    MessageAdType["PrebidOneClick"] = "PrebidOneClick";
    MessageAdType["PrebidOneClickOIO"] = "PrebidOneClickOIO";
})(MessageAdType || (MessageAdType = {}));
exports.default = MessageAdType;
//# sourceMappingURL=MessageAdType.js.map

/***/ }),

/***/ 3459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2802);
var satcheljs_1 = __webpack_require__(2);
var MESSAGEAD_IDKEY = 'MessageAdKey';
exports.default = satcheljs_1.mutatorAction('populateAds', function populateAds(returnedMessageAds) {
    store_1.getStore().messageAdRowStore.clear();
    store_1.getStore().adIds = [];
    returnedMessageAds.forEach(function (returnedMessageAd, index) {
        // Use different message Ad Id key for different Ad type
        // The reason is Facebook Ad will add some special DOM when the Ad item is mounted
        // If using the same key to be swapped with another Ad type, the Facebook DOM will be kept and it causes the bad experience
        var messageAdIdKey = MESSAGEAD_IDKEY + returnedMessageAd.adType + index.toString();
        store_1.getStore().adIds.push(messageAdIdKey);
        returnedMessageAd.adId = messageAdIdKey;
        store_1.getStore().messageAdRowStore.set(messageAdIdKey, returnedMessageAd);
    });
});
//# sourceMappingURL=populateAds.js.map

/***/ }),

/***/ 3460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var removeMessageAd_1 = __webpack_require__(3113);
var store_1 = __webpack_require__(2802);
var satcheljs_1 = __webpack_require__(2);
var owa_analytics_1 = __webpack_require__(12);
exports.default = satcheljs_1.mutator(removeMessageAd_1.default, function (actionMessage) {
    var messageAdToRemove = store_1.getStore().messageAdRowStore.get(actionMessage.removeAdId);
    if (messageAdToRemove) {
        owa_analytics_1.logUsage('RemoveNativeAd', {
            adType: messageAdToRemove.adType,
            adMarket: messageAdToRemove.adMarket,
            adRefreshEvent: messageAdToRemove.adRefreshEvent,
        });
        store_1.getStore().messageAdRowStore.delete(actionMessage.removeAdId);
    }
});
//# sourceMappingURL=removeMessageAdMutator.js.map

/***/ }),

/***/ 3461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.default = satcheljs_1.action('REMOVE_MESSAGEAD_CLEAR_LIST', function (removeAdId) {
    return {
        removeAdId: removeAdId,
    };
});
//# sourceMappingURL=removeMessageAdClearList.js.map

/***/ }),

/***/ 5555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var ItemHeader_1 = __webpack_require__(5556);
var MessageBody_1 = __webpack_require__(5560);
var SubjectHeader_1 = __webpack_require__(5561);
var owa_mail_messagead_store_1 = __webpack_require__(2948);
var owa_messagead_strings_1 = __webpack_require__(2908);
var React = __webpack_require__(3);
var styles = __webpack_require__(3112);
var classNames = __webpack_require__(30).bind(styles);
var MessageAdReadingPane = /** @class */ (function (_super) {
    tslib_1.__extends(MessageAdReadingPane, _super);
    function MessageAdReadingPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageAdReadingPane.prototype.render = function () {
        var currentMessageAd = owa_mail_messagead_store_1.getStore().messageAdRowStore.get(this.props.selectedAdRowId);
        var adSender = currentMessageAd.adSender;
        var adSubject = currentMessageAd.adSubject;
        var adTextsAboveImage = currentMessageAd.adTextsAboveImage;
        var adTextsOnImage = currentMessageAd.adTextsOnImage;
        var adCallToActionTextsOnImage = currentMessageAd.adCallToActionTextsOnImage;
        var adCallToActionTextsBelowImage = currentMessageAd.adCallToActionTextsBelowImage;
        // Delay load the Default Outlook Ad related string
        if (currentMessageAd.adType === "OutlookUpSell" /* OutlookUpSell */) {
            adSender = owa_messagead_strings_1.default.outlookAdSenderText;
            adSubject = owa_messagead_strings_1.default.outlookAdSubject;
            adTextsAboveImage = owa_messagead_strings_1.default.outlookAdPreview;
            adCallToActionTextsBelowImage = owa_messagead_strings_1.default.generalCallToAction;
        }
        return (React.createElement("div", { className: classNames(styles.absolutePosition) },
            React.createElement("div", { className: classNames(styles.flexContainer) },
                React.createElement("div", null,
                    React.createElement(SubjectHeader_1.default, { subject: adSubject, originalPrice: currentMessageAd.adOriginalPrice, currentPrice: currentMessageAd.adCurrentPrice }),
                    React.createElement("div", { className: styles.scrollRegionContainer },
                        React.createElement("div", { className: classNames(styles.scrollRegion, 'customScrollBar') },
                            React.createElement(ItemHeader_1.default, { adSender: adSender, adFavIconurl: currentMessageAd.adFavIconurl }),
                            React.createElement(MessageBody_1.default, { adTextsAboveImage: adTextsAboveImage, adTextsOnImage: adTextsOnImage, adCallToActionTextsOnImage: adCallToActionTextsOnImage, adCallToActionTextsBelowImage: adCallToActionTextsBelowImage, adImageUrl: currentMessageAd.adImageUrl, adImageTargetUrl: currentMessageAd.adImageTargetUrl, adTextsToRenderBody: currentMessageAd.adTextsToRenderBody, adType: currentMessageAd.adType, adMarket: currentMessageAd.adMarket, adRefreshEvent: currentMessageAd.adRefreshEvent })))))));
    };
    return MessageAdReadingPane;
}(React.Component));
exports.default = MessageAdReadingPane;
//# sourceMappingURL=MessageAdReadingPane.js.map

/***/ }),

/***/ 5556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var AdPersona_1 = __webpack_require__(5557);
var ItemHeaderInfobar_1 = __webpack_require__(5558);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var styles = __webpack_require__(3112);
var classNames = __webpack_require__(30).bind(styles);
var ItemHeader = /** @class */ (function (_super) {
    tslib_1.__extends(ItemHeader, _super);
    function ItemHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemHeader.prototype.render = function () {
        return (React.createElement("div", { className: classNames(styles.itemHeaderContainer) },
            React.createElement(AdPersona_1.default, { name: this.props.adSender, imageUrl: this.props.adFavIconurl }),
            React.createElement(ItemHeaderInfobar_1.default, null)));
    };
    ItemHeader = tslib_1.__decorate([
        mobx_react_1.observer
    ], ItemHeader);
    return ItemHeader;
}(React.Component));
exports.default = ItemHeader;
//# sourceMappingURL=ItemHeader.js.map

/***/ }),

/***/ 5557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var Persona_1 = __webpack_require__(234);
var AdPersona = /** @class */ (function (_super) {
    tslib_1.__extends(AdPersona, _super);
    function AdPersona() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdPersona.prototype.render = function () {
        return (React.createElement(Persona_1.Persona, { size: Persona_1.PersonaSize.regular, primaryText: this.props.name, imageUrl: this.props.imageUrl }));
    };
    AdPersona = tslib_1.__decorate([
        mobx_react_1.observer
    ], AdPersona);
    return AdPersona;
}(React.Component));
exports.default = AdPersona;
//# sourceMappingURL=AdPersona.js.map

/***/ }),

/***/ 5558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var InfoBar_1 = __webpack_require__(3106);
var InfoBarMessageViewState_1 = __webpack_require__(2643);
var owa_messagead_strings_1 = __webpack_require__(2908);
var React = __webpack_require__(3);
var styles = __webpack_require__(3112);
var ItemHeaderInfoBar = /** @class */ (function (_super) {
    tslib_1.__extends(ItemHeaderInfoBar, _super);
    function ItemHeaderInfoBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemHeaderInfoBar.prototype.render = function () {
        var infoBarMessageViewState = {
            key: 'MessageListAdDisclaimer',
            source: InfoBarMessageViewState_1.InfoBarMessageSource.ReadingPane,
            rank: InfoBarMessageViewState_1.InfoBarMessageRank.Info,
            messageParts: [owa_messagead_strings_1.default.adMessageInfobarDisclamer],
        };
        var infoBarViewState = {
            messages: [],
        };
        infoBarViewState.messages.push(infoBarMessageViewState);
        return React.createElement(InfoBar_1.default, tslib_1.__assign({}, infoBarViewState, { className: styles.infoBar }));
    };
    return ItemHeaderInfoBar;
}(React.Component));
exports.default = ItemHeaderInfoBar;
//# sourceMappingURL=ItemHeaderInfobar.js.map

/***/ }),

/***/ 5559:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1aOcrsqoQjlk4S6O1R5Nq3{position:absolute;top:0;bottom:0;overflow:hidden}html[dir=ltr] ._1aOcrsqoQjlk4S6O1R5Nq3,html[dir=rtl] ._1aOcrsqoQjlk4S6O1R5Nq3{left:0;right:0}.f9gvL2OZ_taGnoALkl3kW{height:100vh}._3lbce0wPqFwVuEgC4tZuKb,.f9gvL2OZ_taGnoALkl3kW{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}._3lbce0wPqFwVuEgC4tZuKb{position:relative;overflow:hidden;height:100%}._15sOoJYCO-0N-8trwaGYFD{position:relative;width:auto;word-wrap:break-word;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:auto;overflow-y:overlay;height:100%}html[dir=ltr] ._15sOoJYCO-0N-8trwaGYFD{padding:0 20px 0 27px}html[dir=rtl] ._15sOoJYCO-0N-8trwaGYFD{padding:0 27px 0 20px}._3yFR-aXYksTmb2xXVorCa_{font-size:21px;font-weight:100;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-box-flex:0;-ms-flex:0 0 30px;flex:0 0 30px}html[dir] ._3yFR-aXYksTmb2xXVorCa_{border-bottom:solid 1px \"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] ._3yFR-aXYksTmb2xXVorCa_{padding:17px 30px 0 27px}html[dir=rtl] ._3yFR-aXYksTmb2xXVorCa_{padding:17px 27px 0 30px}html[dir] ._3_RftaavK_CScpKOZ7l55i{margin-bottom:10px;padding-top:16px}._2hwVTof2Fa4wy11HEpDu7i{font-size:12px;font-weight:400;outline:none;clear:both}html[dir] ._2hwVTof2Fa4wy11HEpDu7i{margin-top:10px;padding-bottom:10px}._2iELXE7U9fLVMyyYIfLKjl{max-width:1100px}html[dir] ._2iELXE7U9fLVMyyYIfLKjl{margin:auto;text-align:center;padding-top:15px}._1mm8tDB4MUJkHNlFP7kE0V,.dcJClI7i_ov3wluDBXlv-{font-size:21px;font-weight:600;cursor:pointer}._1mm8tDB4MUJkHNlFP7kE0V{color:\"[theme:themePrimary, default:#0078D7]\"}.zM0GwxufxQXN548ewRoj0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}html[dir] .zM0GwxufxQXN548ewRoj0{margin-top:15px}._3itFdp7hcpxOw7jU2_nW1J{position:relative;width:80%;max-height:500px;max-width:1000px;cursor:pointer}._3zfAShvzBnYVWZ_CxbVoNs{width:100%;height:auto}._1OJs23UZvyruytwWLklMVo{position:absolute;bottom:-10px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}html[dir] ._1OJs23UZvyruytwWLklMVo{padding:25px;background:linear-gradient(0deg,rgba(0,0,0,.95),transparent)}html[dir=ltr] ._1OJs23UZvyruytwWLklMVo{background:-webkit-gradient(linear,left bottom,left top,color-stop(0,rgba(0,0,0,.95)),to(transparent))}html[dir=rtl] ._1OJs23UZvyruytwWLklMVo{background:-webkit-gradient(linear,right bottom,right top,color-stop(0,rgba(0,0,0,.95)),to(transparent))}._2Xmx6EIK2KcERpiu0i1oRq{font-size:17px}.NImR2QHZVFKWHAo7o4AlQ{display:block;font-size:19px}html[dir] .NImR2QHZVFKWHAo7o4AlQ{padding-top:10px}._1wcbfgv0c5CHxMV9A7chf1{position:absolute;width:1000px;height:1500px}html[dir] ._1wcbfgv0c5CHxMV9A7chf1{border-width:0;padding-top:15px;margin:auto}html[dir=ltr] ._1wcbfgv0c5CHxMV9A7chf1,html[dir=rtl] ._1wcbfgv0c5CHxMV9A7chf1{left:0;right:0}", ""]);

// exports
exports.locals = {
	"absolutePosition": "_1aOcrsqoQjlk4S6O1R5Nq3",
	"flexContainer": "f9gvL2OZ_taGnoALkl3kW",
	"scrollRegionContainer": "_3lbce0wPqFwVuEgC4tZuKb",
	"scrollRegion": "_15sOoJYCO-0N-8trwaGYFD",
	"subject": "_3yFR-aXYksTmb2xXVorCa_",
	"itemHeaderContainer": "_3_RftaavK_CScpKOZ7l55i",
	"infoBar": "_2hwVTof2Fa4wy11HEpDu7i",
	"adDescriptionTextsOnMessageBodyContainer": "_2iELXE7U9fLVMyyYIfLKjl",
	"adTextsAboveImage": "dcJClI7i_ov3wluDBXlv-",
	"adTextsBelowImage": "_1mm8tDB4MUJkHNlFP7kE0V",
	"div1": "zM0GwxufxQXN548ewRoj0",
	"div2": "_3itFdp7hcpxOw7jU2_nW1J",
	"img1": "_3zfAShvzBnYVWZ_CxbVoNs",
	"div3": "_1OJs23UZvyruytwWLklMVo",
	"span1": "_2Xmx6EIK2KcERpiu0i1oRq",
	"span2": "NImR2QHZVFKWHAo7o4AlQ",
	"adBodyIFrame": "_1wcbfgv0c5CHxMV9A7chf1"
};

/***/ }),

/***/ 5560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var owa_analytics_1 = __webpack_require__(12);
var React = __webpack_require__(3);
var styles = __webpack_require__(3112);
var msNativeAdsScriptLocUrl = '//h6.msn.com/nativeads/ms-nativeads-outlook.min.js';
// const {
//     name: clickNativeAdEventName,
//     customData: clickNativeAdCustomData,
// } = datapoints.ClickNativeAd.datapoint;
var mouseOverIFrame;
var MessageBody = /** @class */ (function (_super) {
    tslib_1.__extends(MessageBody, _super);
    function MessageBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickImageHandler = function (ev) {
            _this.OpenTargetClickWebSite('image');
        };
        _this.onClickTextsAboveImageHandler = function (ev) {
            _this.OpenTargetClickWebSite('textsAboveImage');
        };
        _this.onClickTextsBelowImageHandler = function (ev) {
            _this.OpenTargetClickWebSite('textsBelowImage');
        };
        _this.onClickTextsOnImageHandler = function (ev) {
            _this.OpenTargetClickWebSite('textsOnImage');
        };
        // This is a typical way to detect the click event in a cross-domain iFrame as the cross-domain iFrame itself could not send anything back to the main window
        // When the click happens in the iFrame, the main window will be "blurred" to lose the focus
        _this.onMouseOverIframe = function () {
            mouseOverIFrame = true;
        };
        _this.onMouseOutIframe = function () {
            mouseOverIFrame = false;
        };
        _this.onIFrameClicked = function () {
            if (mouseOverIFrame) {
                _this.LogClickNativeAdDataPoint('iFrame');
            }
        };
        return _this;
    }
    MessageBody.prototype.componentDidMount = function () {
        // When adTextsToRenderBody is not null, we will render the Bing Ad iFrame and listen to the blur event so that we can log the iFrame click situation
        this.props.adTextsToRenderBody && this.showBingAdiFrame();
        window.addEventListener('blur', this.onIFrameClicked);
    };
    MessageBody.prototype.componentWillUnmount = function () {
        window.removeEventListener('blur', this.onIFrameClicked);
    };
    MessageBody.prototype.OpenTargetClickWebSite = function (clickArea) {
        this.LogClickNativeAdDataPoint(clickArea);
        window.open(this.props.adImageTargetUrl, '_blank');
    };
    MessageBody.prototype.LogClickNativeAdDataPoint = function (clickArea) {
        owa_analytics_1.logUsage('ClickNativeAd', {
            messageAdType: this.props.adType,
            userMarket: this.props.adMarket,
            refreshEvent: this.props.adRefreshEvent,
            clickArea: clickArea,
        });
    };
    MessageBody.prototype.renderAdTextsOutsideImage = function (adTextsOutsideImage, adTextsOutsideImageStyleName, isTextsAboveImage) {
        return adTextsOutsideImage == null ? null : (React.createElement("div", { className: styles.adDescriptionTextsOnMessageBodyContainer }, React.createElement("span", { className: adTextsOutsideImageStyleName, onClick: isTextsAboveImage
                ? this.onClickTextsAboveImageHandler
                : this.onClickTextsBelowImageHandler }, adTextsOutsideImage)));
    };
    MessageBody.prototype.renderImage = function (imageUrl, textsOnImageLine1, textsOnImageLine2) {
        var textsOnImageDiv = textsOnImageLine1 == null ? null : (React.createElement("div", { className: styles.div3, onClick: this.onClickTextsOnImageHandler },
            React.createElement("div", { className: styles.span1 },
                React.createElement("span", null, textsOnImageLine1)),
            React.createElement("div", { className: styles.span2 },
                React.createElement("span", null, textsOnImageLine2))));
        return (React.createElement("div", { className: styles.div1 },
            React.createElement("div", { className: styles.div2, onClick: this.onClickImageHandler },
                React.createElement("img", { className: styles.img1, src: imageUrl }),
                textsOnImageDiv)));
    };
    MessageBody.prototype.render = function () {
        var _this = this;
        // Add a clear:both div after messageBody to avoid table with float:left overflowing parent div
        return (React.createElement("div", null,
            this.renderAdTextsOutsideImage(this.props.adTextsAboveImage, styles.adTextsAboveImage, true),
            React.createElement("iframe", { className: styles.adBodyIFrame, onMouseOver: this.onMouseOverIframe, onMouseOut: this.onMouseOutIframe, ref: function (i) {
                    _this.iframeElement = i;
                } }),
            this.renderImage(this.props.adImageUrl, this.props.adTextsOnImage, this.props.adCallToActionTextsOnImage),
            this.renderAdTextsOutsideImage(this.props.adCallToActionTextsBelowImage, styles.adTextsBelowImage, false),
            React.createElement("div", null),
            React.createElement("div", { className: styles.clearBoth })));
    };
    MessageBody.prototype.showBingAdiFrame = function () {
        var _this = this;
        this.iframeElement.onload = function () {
            _this.iframeElement.onload = null;
            _this.iframeElement.setAttribute('scrolling', 'no');
            var iframeDocument = _this.iframeElement.contentDocument;
            if (!iframeDocument.body) {
                iframeDocument.write('<body><div id="owaBingNativeAd"></div></body>');
            }
            var divContainer = _this.iframeElement.contentWindow.document.createElement('div');
            divContainer.id = 'owaBingNativeAd';
            _this.iframeElement.contentWindow.document.body.appendChild(divContainer);
            var nativeAdsContext = {
                msNativeAdsScriptLoc: msNativeAdsScriptLocUrl,
                adResponseText: _this.props.adTextsToRenderBody,
                publisherName: 'Outlook',
            };
            _this.iframeElement.contentWindow.nativeAdsContext = nativeAdsContext;
            var scriptElement = _this.iframeElement.contentWindow.document.createElement('script');
            scriptElement.src = 'https://' + msNativeAdsScriptLocUrl;
            scriptElement.type = 'text/javascript';
            _this.iframeElement.contentWindow.document.body.appendChild(scriptElement);
        };
        this.iframeElement.src = 'about:blank';
    };
    MessageBody = tslib_1.__decorate([
        mobx_react_1.observer
    ], MessageBody);
    return MessageBody;
}(React.Component));
exports.default = MessageBody;
//# sourceMappingURL=MessageBody.js.map

/***/ }),

/***/ 5561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var owa_mail_strings_1 = __webpack_require__(22);
var React = __webpack_require__(3);
var styles = __webpack_require__(3112);
var classNames = __webpack_require__(30).bind(styles);
var SubjectHeader = /** @class */ (function (_super) {
    tslib_1.__extends(SubjectHeader, _super);
    function SubjectHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubjectHeader.prototype.render = function () {
        var subjectDisplay = this.props.subject || owa_mail_strings_1.default.noSubjectText;
        return (React.createElement("div", { className: classNames(styles.subject, 'allowTextSelection'), title: this.props.subject },
            this.props.originalPrice && (React.createElement("span", { className: styles.originalPrice }, this.props.originalPrice)),
            this.props.currentPrice && React.createElement("span", null, this.props.currentPrice),
            subjectDisplay));
    };
    SubjectHeader = tslib_1.__decorate([
        mobx_react_1.observer
    ], SubjectHeader);
    return SubjectHeader;
}(React.Component));
exports.default = SubjectHeader;
//# sourceMappingURL=SubjectHeader.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.MessageAdReadingPane.js